import "./GanttBar.css";

import { JSX } from "react/jsx-runtime";

import {
  KEY_DATE_WIDTH,
  MILESTONE_SIZE,
  PHASE_BAR_HEIGHT,
  ROADMAP_MILESTONE_SIZE,
  TASK_BAR_HEIGHT,
  TASK_BAR_WIDTH,
} from "../../constants";
import { GanttBarProps, GanttKeyDateProps, GanttPhaseBarProps } from "../../models";

export const GanttBar = (props: GanttBarProps): JSX.Element => {
  const { x, rowHeight, color, bgColor, label, title, onClick, onMouseEnter, onMouseLeave } = props;
  const { variant } = props;

  if (variant === "phase") {
    const { width, borderColor, top: laneTop } = props as GanttPhaseBarProps;
    const top = laneTop ?? (rowHeight - PHASE_BAR_HEIGHT) / 2;
    return (
      <button
        type="button"
        className="GanttPhaseBar"
        aria-label={title}
        style={{
          left: x,
          top,
          width,
          height: PHASE_BAR_HEIGHT,
          backgroundColor: bgColor ?? color,
          borderColor: borderColor ?? color,
        }}
        onClick={onClick}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        {label && <span className="body4 GanttPhaseBarLabel">{label}</span>}
      </button>
    );
  }

  if (variant === "task-bar") {
    const top = (rowHeight - TASK_BAR_HEIGHT) / 2;
    return (
      <button
        type="button"
        className="GanttTaskBar"
        aria-label={title}
        style={{
          left: x - TASK_BAR_WIDTH / 2,
          top,
          width: TASK_BAR_WIDTH,
          height: TASK_BAR_HEIGHT,
          backgroundColor: bgColor ?? color,
          borderColor: color,
        }}
        onClick={onClick}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      />
    );
  }

  if (variant === "key-date") {
    // Spans the row's lane stack when it has more than one, so the tick reads across every lane.
    const { height = PHASE_BAR_HEIGHT } = props as GanttKeyDateProps;
    const top = (rowHeight - height) / 2;
    return (
      <button
        type="button"
        className="GanttKeyDate"
        aria-label={title}
        style={{
          left: x - KEY_DATE_WIDTH / 2,
          top,
          width: KEY_DATE_WIDTH,
          height,
          backgroundColor: color,
        }}
        onClick={onClick}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      />
    );
  }

  // milestone / roadmap-milestone
  const size = variant === "roadmap-milestone" ? ROADMAP_MILESTONE_SIZE : MILESTONE_SIZE;
  const top = (rowHeight - size) / 2;
  return (
    <button
      type="button"
      className={`GanttMilestone ${variant === "roadmap-milestone" ? "GanttMilestone_roadmap" : "GanttMilestone_task"}`}
      aria-label={title}
      style={{
        left: x - size / 2,
        top,
        width: size,
        height: size,
        backgroundColor: bgColor ?? color,
        borderColor: color,
      }}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    />
  );
};
